// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1MKEg","Logo":"Header_Logo__11OHU"};